// Enum for table columns (API response fields)
export enum QuotationTableColumn {
  DATE = "date",
  CUI_NO = "contacts_customer_unique_identification_number",
  SALES_LEAD_ID = "sales_lead_id",
  LEAD_NAME = "lead_name",
  COMPANY_NAME = "company_name",
  ENQUIRY_CATEGORY_NAME = "enquiry_category_name",
  LAST_FOLLOWUP_DATE = "last_followup_date",
  STATUS = "is_closed",
}

// Enum for export columns (backend expected fields)
export enum QuotationExportColumn {
  DATE = "date",
  CUI_NO = "contacts_customer_unique_identification_number",
  SALES_LEAD_ID = "sales_lead_id",
  LEAD_NAME = "lead_name",
  COMPANY_NAME = "company_name",
  ENQUIRY_CATEGORY_NAME = "enquiry_category_name",
  LAST_FOLLOWUP_DATE = "last_followup_date",
  STATUS = "status",
}

// Column display names mapping (for UI)
export const QuotationColumnLabels: Record<QuotationTableColumn, string> = {
  [QuotationTableColumn.DATE]: "Date",
  [QuotationTableColumn.CUI_NO]: "CUI No.",
  [QuotationTableColumn.SALES_LEAD_ID]: "Code",
  [QuotationTableColumn.LEAD_NAME]: "Lead Name",
  [QuotationTableColumn.COMPANY_NAME]: "Company",
  [QuotationTableColumn.ENQUIRY_CATEGORY_NAME]: "Enquiry Category",
  [QuotationTableColumn.LAST_FOLLOWUP_DATE]: "Last Followed",
  [QuotationTableColumn.STATUS]: "Status",
};

// Default selected columns for export (all true)
export const getDefaultQuotationSelectedColumns = () => ({
  [QuotationExportColumn.DATE]: true,
  [QuotationExportColumn.CUI_NO]: true,
  [QuotationExportColumn.SALES_LEAD_ID]: true,
  [QuotationExportColumn.LEAD_NAME]: true,
  [QuotationExportColumn.COMPANY_NAME]: true,
  [QuotationExportColumn.ENQUIRY_CATEGORY_NAME]: true,
  [QuotationExportColumn.LAST_FOLLOWUP_DATE]: true,
  [QuotationExportColumn.STATUS]: true,
});

export const statusFilterOptions = [
  { id: "true", name: "Active" },
  { id: "false", name: "Closed" },
];
